import React, { useState } from 'react';
import { Modal, Button, Form, Table, Alert, Spinner } from 'react-bootstrap';
import { useLancamentoPerdas } from '../../../contexts/MP/LancamentoPerdasContext';

const ModalLancamentoPerdas = () => {
    const {
        showModal,
        showConfirmacao,
        isLoading,
        isProcessing,
        showSuccess,

        pecas,
        amostra,
        motivos,
        reqMaterial,
        errosLancamento,

        observacao,

        habilitarModoLote,
        isBatchMode,
        quantidadeBatch,
        motivoBatch,

        fecharModal,
        fecharConfirmacao,
        confirmarLancamentoPerdas,
        cancelarLancamentoPerdas,
        processarLancamentoPerdas,
        toggleBatchMode,

        handleObservacaoChange,
        handleQuantidadeBatchChange,
        handleMotivoBatchChange,
    } = useLancamentoPerdas();

    // Função para calcular a quantidade total de material baseada na soma das perdas das peças
    const calcularQuantidadeTotalMaterial = () => {
        if (!Array.isArray(pecas)) return 0;

        return pecas.reduce((total, peca) => {
            const qtdPeca = parseFloat(peca.qtdeLancar) || 0;
            return total + qtdPeca;
        }, 0);
    };

    // Estado para forçar re-renderização quando quantidades mudarem
    const [, setUpdateTrigger] = useState(0);

    // Calcular total em tempo real
    const quantidadeTotalMaterial = calcularQuantidadeTotalMaterial();

    // Handler para atualização de quantidade que força re-renderização
    const handleQuantidadeChange = (peca, novaQtd) => {
        peca.qtdeLancar = novaQtd;
        setUpdateTrigger(prev => prev + 1); // Força re-renderização        
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        processarLancamentoPerdas();
    };

    if (showConfirmacao) {
        return (
            <Modal
                show={showConfirmacao}
                onHide={fecharConfirmacao}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Lançar Perdas?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center">
                        <h5>Deseja lançar as perdas?</h5>
                        <Alert variant="warning" className="mt-3">
                            <strong>⚠️ Atenção!</strong><br />
                            Estas informações atualizarão o banco de dados do LINX
                        </Alert>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cancelarLancamentoPerdas}>
                        Não
                    </Button>
                    <Button variant="primary" onClick={confirmarLancamentoPerdas}>
                        Sim
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    if (showSuccess) {
        return (
            <Modal
                size="lg"
                backdrop="static"
                show={showModal}
                onHide={fecharModal}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Lançamento de Perdas - Sucesso</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="success">
                        <Alert.Heading>Lançamento realizado com sucesso!</Alert.Heading>
                        <p>
                            {reqMaterial.includes(',') ? 'Requisições de Material:' : 'Requisição de Material:'} <strong>{reqMaterial}</strong>
                        </p>
                        <hr />
                        <p className="mb-0">
                            As perdas foram registradas no sistema.
                            {reqMaterial.includes(',') && ' Múltiplos lançamentos foram criados conforme os motivos selecionados.'}
                            <br />Você pode fechar esta janela.
                        </p>

                        {/* Exibir erros se houver */}
                        {Array.isArray(errosLancamento) && errosLancamento.length > 0 && (
                            <>
                                <hr />
                                <Alert variant="warning" className="mt-3">
                                    <Alert.Heading>Alguns lançamentos falharam:</Alert.Heading>
                                    <ul className="mb-0">
                                        {errosLancamento.map((erro, index) => (
                                            <li key={index}>{erro}</li>
                                        ))}
                                    </ul>
                                </Alert>
                            </>
                        )}
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={fecharModal}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <Modal
            size="xl"
            backdrop="static"
            show={showModal}
            onHide={fecharModal}
            centered
        >
            <Modal.Header closeButton>
                <div className="w-100 d-flex justify-content-between align-items-center me-3">
                    <Modal.Title>
                        Lançamento de Perdas - Revisão MP
                        {habilitarModoLote && (
                            <span className={`ms-2 badge ${isBatchMode ? 'bg-info' : 'bg-secondary'}`}>
                                {isBatchMode ? 'Modo Lote' : 'Modo Individual'}
                            </span>
                        )}
                    </Modal.Title>
                    {habilitarModoLote && (
                        <Button
                            variant={isBatchMode ? "warning" : "info"}
                            size="md"
                            onClick={toggleBatchMode}
                            disabled={isLoading}
                            className="fw-bold"
                        >
                            <i className="bi bi-arrow-left-right me-2"></i>
                            Alterar para lançamento {isBatchMode ? 'individual' : 'em lote'}
                        </Button>
                    )}
                </div>
            </Modal.Header>

            <Form>
                <Modal.Body>
                    <div className="mb-4 p-3 bg-light rounded">
                        <h5>Informações do Material</h5>
                        <div className="row">
                            <div className="col-md-6">
                                <strong>Material:</strong> {amostra.material || 'N/A'}
                            </div>
                            <div className="col-md-6">
                                <strong>Cor Material:</strong> {amostra.cormaterial || 'N/A'}
                            </div>
                            <div className="col-md-6">
                                <strong>Descrição:</strong> {amostra.descricaomaterial || 'N/A'}
                            </div>
                            <div className="col-md-6">
                                <strong>Fornecedor:</strong> {amostra.nomeCliFor || 'N/A'}
                            </div>
                        </div>
                    </div>

                    {isBatchMode && (
                        <>
                            <Alert variant="info" className="mb-4">
                                <Alert.Heading>
                                    <i className="bi bi-info-circle me-2"></i>
                                    Lançamento em Lote
                                </Alert.Heading>
                                <p className="mb-0">
                                    Neste modo, a mesma <strong>quantidade</strong> e <strong>motivo</strong> serão aplicados para todas as peças listadas abaixo.
                                </p>
                            </Alert>

                            <div className="mb-4 p-4 border border-primary rounded bg-light">
                                <h5 className="text-primary mb-3">Informações do Lote</h5>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>
                                                <strong>Quantidade de Perda (por peça)</strong>
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={quantidadeBatch}
                                                onChange={handleQuantidadeBatchChange}
                                                placeholder="Ex: 2.5"
                                                disabled={isLoading}
                                                required
                                                className="form-control-lg"
                                            />
                                            <Form.Text className="text-muted">
                                                Esta quantidade será aplicada para TODAS as peças
                                            </Form.Text>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Group>
                                            <Form.Label>
                                                <strong>Motivo da Perda</strong>
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                value={motivoBatch}
                                                onChange={handleMotivoBatchChange}
                                                disabled={isLoading}
                                                required
                                                className="form-select-lg"
                                            >
                                                <option value={-1}>Selecione o motivo...</option>
                                                {Array.isArray(motivos) && motivos.map((motivo) => (
                                                    <option key={motivo.IdMotivo} value={motivo.IdMotivo}>
                                                        {motivo.Motivo}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Text className="text-muted">
                                                Este motivo será aplicado para TODAS as peças
                                            </Form.Text>
                                        </Form.Group>
                                    </div>
                                </div>

                                {quantidadeBatch && parseFloat(quantidadeBatch) > 0 && pecas.length > 0 && (
                                    <div className="mt-3 p-3 bg-white border border-info rounded">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <strong className="text-info">Total de Material a ser Lançado:</strong>
                                                <br />
                                                <small className="text-muted">
                                                    {quantidadeBatch} × {pecas.length} peças
                                                </small>
                                            </div>
                                            <div className="text-end">
                                                <span className="fs-3 fw-bold text-info">
                                                    {(parseFloat(quantidadeBatch) * pecas.length).toLocaleString('pt-BR', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                                </span>
                                                <small className="d-block text-muted">unidades</small>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="mb-4">
                                <h5>Peças que Receberão o Lançamento</h5>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Peça</th>
                                            <th>Metro Fornec.</th>
                                            <th>Metragem Relógio</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(pecas) && pecas.map((peca, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td><strong>{peca.peca}</strong></td>
                                                    <td>{peca.metroForn}</td>
                                                    <td>{peca.relogio}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                                <small className="text-muted">
                                    Total de peças: <strong>{pecas.length}</strong>
                                </small>
                            </div>
                        </>
                    )}

                    {!isBatchMode && (
                        <>
                            <div className="mb-4 p-3 bg-info bg-opacity-10 border border-info rounded">
                                <div className="row align-items-center">
                                    <div className="col-md-8">
                                        <h6 className="mb-0 text-info">
                                            Quantidade Total de Material Enviada
                                        </h6>
                                        <small className="text-muted">
                                            Soma automática das quantidades de perdas de todas as peças
                                        </small>
                                    </div>
                                    <div className="col-md-4 text-end">
                                        <span className="fs-4 fw-bold text-info">
                                            {quantidadeTotalMaterial.toLocaleString('pt-BR', {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 2
                                            })}
                                        </span>
                                        <small className="d-block text-muted">unidades</small>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-4">
                                <h5>Peças Disponíveis para Lançamento de Perdas</h5>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Peça</th>
                                            <th>Partida</th>
                                            <th>Metro Fornec.</th>
                                            <th>Metragem Relógio</th>
                                            <th>Motivo da Perda</th>
                                            <th>Qtd. Perda</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(pecas) && pecas.map((peca, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td><strong>{peca.peca}</strong></td>
                                                    <td>UNICA</td>
                                                    <td>{peca.metroForn}</td>
                                                    <td>{peca.relogio}</td>
                                                    <td>
                                                        <Form.Select
                                                            onChange={(e) => {
                                                                const novoMotivo = e.target.value;
                                                                peca.motivoSelecionado = novoMotivo;
                                                            }}
                                                            disabled={isLoading}
                                                            defaultValue={-1}
                                                            style={{ minWidth: '150px' }}
                                                        >
                                                            <option value={-1}>Selecione...</option>
                                                            {Array.isArray(motivos) && motivos.map((motivo) => (
                                                                <option key={motivo.IdMotivo} value={motivo.IdMotivo}>
                                                                    {motivo.Motivo}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            min="0"
                                                            step="0.01"
                                                            value={peca.qtdeLancar || ''}
                                                            onChange={(e) => {
                                                                const novaQtd = parseFloat(e.target.value) || 0;
                                                                handleQuantidadeChange(peca, novaQtd);
                                                            }}
                                                            style={{
                                                                width: '80px',
                                                                backgroundColor: (() => {
                                                                    const qtdPerda = parseFloat(peca.qtdeLancar) || 0;
                                                                    const metroForn = parseFloat(peca.metroForn) || 0;
                                                                    if (qtdPerda > 0 && metroForn > 0) {
                                                                        const percentual = (qtdPerda / metroForn) * 100;
                                                                        return percentual > 5 ? 'rgba(255, 0, 0, 0.2)' : '';
                                                                    }
                                                                    return '';
                                                                })()
                                                            }}
                                                            disabled={isLoading}
                                                            placeholder="0"
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                                <small className="text-muted">
                                    * Informe a quantidade de perda para cada peça conforme necessário
                                </small>
                            </div>
                        </>
                    )}

                    <div className="row">
                        <div className="col-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Observação</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={observacao}
                                    onChange={handleObservacaoChange}
                                    placeholder="Descreva as observações sobre o lançamento de perdas (opcional)"
                                    disabled={isLoading}
                                />
                            </Form.Group>
                        </div>
                    </div>

                    {Array.isArray(pecas) && pecas.length === 0 && (
                        <Alert variant="warning">
                            <strong>Atenção:</strong> Não há peças disponíveis para lançamento.
                        </Alert>
                    )}

                </Modal.Body>

                <Modal.Footer>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", width: "100%" }}>
                        <Button
                            variant="secondary"
                            type="button"
                            onClick={() => processarLancamentoPerdas(true)}
                            disabled={isLoading || !Array.isArray(pecas) || pecas.length === 0}
                        >
                            {isLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Processando...
                                </>
                            ) : (
                                'Lançar Perdas com Etiquetas'
                            )}
                        </Button>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <Button
                                variant="secondary"
                                onClick={fecharModal}
                                disabled={isLoading}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="primary"
                                type="button"
                                onClick={() => processarLancamentoPerdas(false)}
                                disabled={isLoading || !Array.isArray(pecas) || pecas.length === 0}
                            >
                                {isLoading ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        Processando...
                                    </>
                                ) : (
                                    'Lançar Perdas'
                                )}
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ModalLancamentoPerdas;
